<div class="dialogCustom--maxHeight">
  <div mat-dialog-title>
    <div data-testId="generate-new-report-modal-title" class="h4 mb-0">{{data.title}}</div>
    <button data-testId="close-report-history-icon" mat-icon-button (click)="onClose()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="d-flex flex-column noPadding">
    <section class="section section--wShadow">
      <div class="alert w-100">
        <h4
          data-testId="generate-new-report-section-title"
          class="mb-1"
          i18n="@@dpr.reportHistoryModal.titleGenerateNewReport"
        >
          Generate new report
        </h4>
        <div
          data-testId="generate-new-report-explanation-text"
          class="mb-3"
          i18n="@@dpr.reportHistoryModal.txtResolution"
        >
          Standard resolution: Standard processing time and file size, standard visibility of image details.
          <br />
          High resolution: Increased processing time and file size, improved visibility of image details.
        </div>

        <button
          data-testId="download-standard-resolution"
          mat-flat-button
          color="primary"
          class="mr-3"
          (click)="generate(false)"
          cdkFocusInitial
        >
          <mat-icon svgIcon="cloud-download"></mat-icon>
          <span i18n="@@dpr.reportHistoryModal.btnStandardResolution">Standard resolution</span>
        </button>
        <button data-testId="download-high-resolution" mat-flat-button class="mat-secondary" (click)="generate(true)">
          <mat-icon svgIcon="cloud-download"></mat-icon>
          <span i18n="@@dpr.reportHistoryModal.btnHighResolution">High resolution</span>
        </button>
      </div>
    </section>

    <div class="overflow-y-auto p-3 bg-light">
      <mat-card class="noPadding mb-0">
        <section class="section">
          <div class="section_header">
            <span
              data-testId="previously-generated-reports"
              class="section_title"
              i18n="@@dpr.reportHistoryModal.titlePreviouslyGeneratedReports"
            >
              Previously generated reports
            </span>
          </div>
          <hr class="extended" />
          <div class="section_body">
            <div *ngIf="processedReports?.length; else noHistoryTemplate">
              <ng-container *ngLet="(processedReports | sort : 'generatedOn' : 'desc') as sortedReports">
                <ng-template
                  *ngTemplateOutlet="reportsListingTemplate; context: { $implicit: sortedReports }"
                ></ng-template>
              </ng-container>
            </div>

            <!-- No reports message -->
            <ng-template #noHistoryTemplate>
              <i data-testId="report-history-not-available" i18n="@@dpr.reportHistoryModal.txtNoHistory">
                Previously generated reports are not available.
              </i>
            </ng-template>
          </div>
        </section>
      </mat-card>
    </div>
  </div>

  <div mat-dialog-actions>
    <button data-testId="close-report-history" mat-button color="primary" (click)="onClose()">
      {{StaticMessage.CloseButton | staticMessage}}
    </button>
  </div>
</div>

<ng-template #reportsListingTemplate let-generatedReports>
  <ng-container *ngFor="let report of generatedReports; let first = first;let index = index">
    <hr *ngIf="!first" class="extended" />
    <ng-template *ngTemplateOutlet="reportHistoryItemTemplate; context: { report: report, index: index}"></ng-template>
  </ng-container>
</ng-template>

<ng-template #reportHistoryItemTemplate let-report="report" let-index="index">
  <div [attr.data-testId]="'report-container-' + index" class="d-flex align-items-start">
    <mat-icon svgIcon="history" class="historyIcon"></mat-icon>

    <div class="flex-1">
      <h5 data-testId="generated-on" class="mb-0">{{report.generatedOnText}}</h5>
      <div data-testId="generated-by" class="text-small text-muted">
        {{report.generatedByText + ' | ' + report.revisionNumberText}}
      </div>
      <div class="imageCompressionTypeContainer mt-1">
        <ng-container *ngIf="report.imageCompressionType === ImageCompressionType.None">
          <app-chip
            data-testId="high-resolution-icon"
            icon="quality-high"
            matTooltip="High resolution images"
            i18n-matTooltip="@@dpr.reportHistoryModal.attrHighResolutionImg"
            color="success"
          ></app-chip>
        </ng-container>
        <ng-container *ngIf="report.reportGenerationType === ReportGenerationType.ESign">
          <app-chip
            data-testId="generated-for-esign-icon"
            icon="file-sign"
            matTooltip="Generated for E-Sign"
            i18n-matTooltip="@@dpr.reportHistoryModal.attrGeneratedForESign"
            color="success"
          ></app-chip>
        </ng-container>
        <app-chip
          data-testId="locked-icon"
          *ngIf="report.isLocked"
          icon="lock-outline"
          matTooltip="Locked"
          i18n-matTooltip="@@dpr.reportHistoryModal.attrLocked"
          color="grey"
        ></app-chip>
      </div>
    </div>

    <button
      data-testId="download-previously-downloaded-report"
      mat-flat-button
      class="mat-secondary"
      (click)="download(report.fileUrl)"
    >
      <mat-icon svgIcon="cloud-download"></mat-icon>
      {{StaticMessage.DownloadButton | staticMessage}}
    </button>
  </div>
</ng-template>
